import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { CartInfoPublic } from '../fragments';

export default gql`
  mutation updateCart($input: CartUpdateInput!) {
    updateCart(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      cart {
        ...CartInfoPublic
      }
    }
  }
  ${CartInfoPublic}
  ${ErrorMessageInfo}
`;
